import { Icon16Checkmark, Typography } from "@cur8/maneki";
import { Measurement } from "@cur8/rich-entity";
import { MetricGroup } from "./measurementConfig";
import styles from "./styles.module.sass";

interface GroupTileProps {
  group: MetricGroup;
  existingByMetric: Map<string, Measurement>;
  onClick: () => void;
}

export function GroupTile({
  group,
  existingByMetric,
  onClick,
}: GroupTileProps) {
  const doneCount = group.metrics.filter((m) =>
    existingByMetric.has(m.metricName)
  ).length;
  const isDone = doneCount === group.metrics.length;

  return (
    <button
      type="button"
      className={styles.tile}
      data-done={isDone || undefined}
      onClick={onClick}
    >
      <div className={styles.tileHeader}>
        <Typography variant="label-s">{group.label}</Typography>
        {isDone && (
          <span className={styles.tileCheck}>
            <Icon16Checkmark />
          </span>
        )}
      </div>
      <Typography variant="body-s" color={isDone ? "inverted" : "subtle"}>
        {isDone ? "Done" : `${doneCount}/${group.metrics.length}`}
      </Typography>
    </button>
  );
}
